import { ReactComponent as TwitterXIcon } from 'src/images/svgs/socials/x-twitter.svg';
import { ReactComponent as FacebookIcon } from 'src/images/svgs/socials/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';

import { LinkProps, SocialIconLinks, SocialName } from './page-share.types';

export const socialIconLinks: SocialIconLinks[] = [
  {
    href: ({ url, description, campaign: { utmCampaign, utmSource } }: LinkProps) => {
      let baseLink = `https://x.com/intent/post?url=${url}&via=realtryhackme&text=${description}&hashtags=tryhackme`;
      if (utmSource !== undefined && utmCampaign !== undefined) {
        baseLink += `&utm_source=${utmSource}&utm_medium=twitter_share&utm_campaign=${utmCampaign}`;
      }
      return baseLink;
    },
    icon: TwitterXIcon,
    name: SocialName.x,
  },
  {
    href: ({ url, campaign: { utmCampaign, utmSource } }: LinkProps) => {
      let baseLink = `https://www.linkedin.com/feed/?linkOrigin=LI_BADGE&shareActive=true&shareUrl=${url}`;
      if (utmSource && utmCampaign) {
        baseLink += `&utm_source=${utmSource}&utm_medium=linkedin_share&utm_campaign=${utmCampaign}`;
      }
      return baseLink;
    },
    icon: LinkedinIcon,
    name: SocialName.linkedin,
  },
  {
    href: ({ url, description, campaign: { utmCampaign, utmSource } }: LinkProps) => {
      let baseLink = `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${description}`;
      if (utmCampaign && utmSource) {
        baseLink += `&utm_source=${utmSource}&utm_medium=fb_share&utm_campaign=${utmCampaign}`;
      }
      return baseLink;
    },
    icon: FacebookIcon,
    name: SocialName.facebook,
  },
];
